<div class="container-fluid">
  <div class="row">
    <div class="col-12">
      <div class="page-title-box d-flex align-items-center justify-content-between">
        <h4 class="mb-0">Client Registration</h4>
        <div class="page-title-right">
          <ol class="breadcrumb m-0">
            <li class="breadcrumb-item"><a href="javascript: void(0);">Dashboard</a></li>
            <li class="breadcrumb-item"><a href="javascript: void(0);" (click)="goBack()">Admin</a></li>
            <li class="breadcrumb-item active">Register Client</li>
          </ol>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    <div class="col-12">
      <div class="card">
        <div class="card-body">
          <h4 class="card-title mb-4">Register New Client</h4>
          
          <form (ngSubmit)="onSubmit()" #clientForm="ngForm">
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="name" class="form-label">Full Name *</label>
                  <input type="text" class="form-control" id="name" name="name" [(ngModel)]="client.name" required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="email" class="form-label">Email *</label>
                  <input type="email" class="form-control" id="email" name="email" [(ngModel)]="client.email" required>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="company" class="form-label">Company</label>
                  <input type="text" class="form-control" id="company" name="company" [(ngModel)]="client.company">
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="proxmoxUser" class="form-label">Proxmox Username *</label>
                  <input type="text" class="form-control" id="proxmoxUser" name="proxmoxUser" [(ngModel)]="client.proxmoxUser" required>
                  <div class="form-text">This should match the Proxmox user account for this client</div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="password" class="form-label">Password *</label>
                  <input type="password" class="form-control" id="password" name="password" [(ngModel)]="password" required>
                </div>
              </div>
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="confirmPassword" class="form-label">Confirm Password *</label>
                  <input type="password" class="form-control" id="confirmPassword" name="confirmPassword" [(ngModel)]="confirmPassword" required>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="mb-3">
                  <label for="status" class="form-label">Status</label>
                  <select class="form-select" id="status" name="status" [(ngModel)]="client.status">
                    <option value="active">Active</option>
                    <option value="inactive">Inactive</option>
                    <option value="suspended">Suspended</option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="d-flex justify-content-between">
              <button type="button" class="btn btn-secondary" (click)="goBack()">
                <i class="mdi mdi-arrow-left me-1"></i> Back to Dashboard
              </button>
              <button type="submit" class="btn btn-primary" [disabled]="!clientForm.form.valid || isLoading">
                <span *ngIf="isLoading" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                <i class="mdi mdi-content-save me-1"></i> Register Client
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  
  <!-- Success/Error Messages -->
  <div class="row" *ngIf="successMessage || errorMessage">
    <div class="col-12">
      <div class="alert" [ngClass]="{
        'alert-success': successMessage,
        'alert-danger': errorMessage
      }" role="alert">
        {{ successMessage || errorMessage }}
      </div>
    </div>
  </div>
</div>